module.exports = __webpack_public_path__ + "static/img_9849-87ded87e27af093c659f8dfcbaa7d6fc.webp";